export const BAC_ACTION_PREFIX = `[become-a-customer]`;
